import styled from 'styled-components'
import { Trans } from 'react-i18next'
import { useTranslation } from 'next-i18next'

import CheckoutPanel from '../CheckoutPanel'
import ExpressCheckout from './ExpressCheckout'
import { CheckoutQA } from 'shared/dataAttributes'
import { SVGIcon } from 'shared/components/Icons'
import { colors } from 'shared/lib'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'

const TP = 'checkout.components.ExpressCheckoutPanel.ExpressCheckoutPanel'

const Title = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
`

const Optional = styled.span`
  color: ${colors.FC2_GREY};
  margin-left: 5px;
`

const LockIcon = styled(SVGIcon).attrs({
  name: 'lock',
})`
  margin-right: 10px;
`

const ExpressCheckoutPanel = () => {
  const { panels } = useCheckoutContext()
  const { t } = useTranslation()

  if (panels.expressCheckout.disabled) {
    return null
  }

  return (
    <CheckoutPanel
      title={
        <Title>
          <LockIcon />
          <Trans i18nKey={`${TP}.title`} t={t}>
            Express Checkout <Optional> (Optional) </Optional>
          </Trans>
        </Title>
      }
      name="expressCheckout"
      editable={false}
      hideIndicator
      qaAttr={CheckoutQA.ExpressCheckout}
      summarizedContent={<ExpressCheckout />}
    />
  )
}

export default ExpressCheckoutPanel
